export default __webpack_public_path__ + "static/media/profile.99a9e3bf.png";